import { Flex, theme } from 'modules/ui';
import { DisplayTitle } from 'modules/ui/typography/Typography';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';
import { FormMaxWidth } from '../../layout/styled';

export const StyledLandingPageContentContainer = styled.div<{
  backgroundImage: any;
}>`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;

  width: 100vw;
  min-height: max(calc(100vh - 4.4rem), ${FormMaxWidth});
  background-image: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.75) 8.4%,
      rgba(0, 0, 0, 0.25) 91.51%
    ),
    url(${(props) => props.backgroundImage});

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  padding: 1rem;

  ${mediaQuery('md')} {
    padding: 3.125rem;
  }
`;

export const StyledTopContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledTitle = styled(DisplayTitle)`
  color: ${theme.colors.primaryW};
  background-color: var(--contrast-background);
`;

export const StyledMiddleContainer = styled(Flex)`
  * {
    color: ${theme.colors.primaryW};
    background-color: var(--contrast-background);
  }

  li {
    margin-left: -1rem;
  }

  p {
    margin-bottom: 0rem;
  }
`;

export const StyledBottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  
`;

export const StyledCalculatorContainer = styled.div`
  flex: 1;
  color: ${({theme}) => theme.colors.primaryW};

  h3,
  p {
    color: ${theme.colors.primaryW};
    background-color: var(--contrast-background);
  }
`;

export const StyledButtonContainer = styled.div`
  padding-top: 0.688rem;
  display: flex;
  flex-direction: column;
  width: 100%;

  & > *:not(:last-child) {
    margin-bottom: 1rem;
  }

  ${mediaQuery('md')} {
    flex-direction: row;

    & > *:not(:last-child) {
      margin-right: 1.5rem;
    }
  }
`;
